<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>Conte-nos um pouco mais sobre a sua empresa</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-10 col-xl-10">
        <form @submit="onSubmit">
          <div class="form-group">
            <label for="informacaoInstitucional">Sobre a minha empresa</label>
            <textarea class="form-control form-control-lg" v-model="informacaoInstitucional" rows="5" placeholder="Como começou a empresa? Quais os produtos/serviços que a empresa oferece? A quanto tempo está nessa mesma localização? O imóvel que a empresa se encontra é próprio ou alugado? Quais as projeções futuras? Informações sobre os sócios: Experiência na área, formação, etc." required></textarea>
          </div>
          <div class="text-center fixedOptions">
            <button v-focus class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shouldShowTip: false,
      informacaoInstitucional: this.solicitacao.Empresa.InformacaoInstitucional
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          InformacaoInstitucional: this.informacaoInstitucional
        }
      }
      this.$emit('on-submit', newData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/InstitutionalInformationStep.vue